
(function () {
    'use strict';

    angular.module('thankview.videoRequest')
        .directive('overlayRequestSubmit', ['$rootScope', '$sce', function ($rootScope, $sce) {
            return {
                restrict: 'E',
                scope: true,
                templateUrl: '/api/view/videoRequestSubmit',
                link: function (scope) {
                    scope.$on('open-overlay-request-submit', function ($event, agreeMessage) {
                        scope.agreeMessage = $sce.trustAsHtml(agreeMessage);
                        scope.$broadcast('open-overlay');
                    });

                    /**
                     * Validator for email/phone input. Runs on every change event
                     */
                    scope.isValidEmailOrPhone = function () {
                        if (!scope.guestEmail) return;
                        if (!validateEmail(scope.guestEmail) && !validatePhone(formatPhone(scope.guestEmail))) {
                            scope.requestInfo.pubEmail.$setValidity('format', false);
                        } else {
                            scope.requestInfo.pubEmail.$setValidity('format', true);
                        }
                    };

                    scope.submitRequestForm = function () {
                        if (!scope.requestInfo.$valid) return;
                        // post info back to video-request.js
                        $rootScope.$broadcast('request-form-submitted', {
                            name: scope.guestName + ' ' + scope.guestLastName,
                            recipient_name: scope.recipientName,
                            email: scope.guestEmail,
                            agree: true,
                        });
                        // clear recipient name after submitting
                        // in case user wants to reply again for a different donor
                        scope.recipientName = '';
                        scope.$broadcast('force-close-overlay');
                    };
                },
            };
        }]);
}());
